// src/components/Layout.tsx

import { useLocation } from 'react-router-dom';
import Appbar from './Appbar';
import Sidebar from './Sidebar';

const Layout = (props: { children: any }) => {
  const location = useLocation();
  const isLegalPage = location.pathname.startsWith('/legal/');

  // Yasal metin sayfaları için sadece içerik göster
  if (isLegalPage) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
          {props.children}
      </div>
    );
  }

  // Normal sayfalar için tam layout göster
  return (
    <div style={{ display: 'flex', flexDirection: 'row', height: '100vh' }}>
      <Sidebar />
      <div style={{ display: 'flex', flexGrow: 1, flexDirection: 'column', paddingLeft: 270 }}> {/* Header yüksekliğine göre ayarla */}
        <Appbar />
        <main style={{ flexGrow: 1, padding: '24px' }}>
          {props.children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
